var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegalsDecoration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 405,
    height: 28,
    viewBox: "0 0 405 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 1,
    transform: "matrix(-1 0 0 1 180 16.9991)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.0662,
    height: 1.25171,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 189.936 26.9503)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.168,
    y: 26.9445,
    width: 13,
    height: 1.25171,
    transform: "rotate(-45 188.168 26.9445)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 171,
    height: 1,
    transform: "matrix(-1 0 0 1 183 19.9991)",
    fill: "url(#paint0_linear_157_912)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 16.9991,
    width: 180,
    height: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.064,
    y: 26.9503,
    width: 14.0662,
    height: 1.25171,
    transform: "rotate(-45 215.064 26.9503)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 1.25171,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 216.832 26.9445)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 19.9991,
    width: 171,
    height: 1,
    fill: "url(#paint1_linear_157_912)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197,
    y: 11.6554,
    width: 8,
    height: 8,
    transform: "rotate(-45 197 11.6554)",
    fill: "#AC9FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 11.6066,
    width: 15,
    height: 15,
    transform: "rotate(-45 192 11.6066)",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_157_912",
    x1: 1,
    y1: 0.999771,
    x2: 86.5,
    y2: 1.49985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_157_912",
    x1: 223,
    y1: 20.9989,
    x2: 308.5,
    y2: 21.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalsDecoration);
export default __webpack_public_path__ + "static/media/legals-decoration.c92dcdc90546a250a5d04dee206df465.svg";
export { ForwardRef as ReactComponent };